import { cloneElement } from '../_util/vnode';
import { flattenChildren } from '../_util/props-util';
const InputElement = (_, { attrs, slots }) => {
    var _a;
    const children = flattenChildren((_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots))[0];
    return cloneElement(children, Object.assign({}, attrs));
};
InputElement.inheritAttrs = false;
export default InputElement;
